import { render } from "./SettingsView.vue?vue&type=template&id=9d0f967e"
import script from "./SettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=9d0f967e&lang=css"

import exportComponent from "/Volumes/Projects/wp_all_repo/wp-content/plugins/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/views/SettingsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d0f967e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d0f967e', __exports__)) {
    console.log('reload')
    api.reload('9d0f967e', __exports__)
  }
  
  module.hot.accept("./SettingsView.vue?vue&type=template&id=9d0f967e", () => {
    console.log('re-render')
    api.rerender('9d0f967e', render)
  })

}


export default __exports__